let AppImages = [
  {
    "container_format": "bare",
    "min_ram": 0,
    "updated_at": "2021-09-22T10:27:56Z",
    "file": "/v2/images/20e4dc3d-75dc-4183-884a-1656cccca6a3/file",
    "owner": "b7e277b7d53449f9941b9ea61cae99e3",
    "id": "20e4dc3d-75dc-4183-884a-1656cccca6a3",
    "size": 1043726336,
    "self": "/v2/images/20e4dc3d-75dc-4183-884a-1656cccca6a3",
    "disk_format": "qcow2",
    "os_hash_algo": "sha512",
    "schema": "/v2/schemas/image",
    "status": "active",
    "tags": [
      "application_stack"
    ],
    "hw_qemu_guest_agent": "yes",
    "visibility": "public",
    "min_disk": 0,
    "virtual_size": null,
    "name": "Django-Ubuntu-20.04 LTS-x86_64",
    "checksum": "7d0b6292c175a69732a6a76605d5b7ce",
    "created_at": "2021-09-22T10:27:30Z",
    "os_hidden": false,
    "protected": false,
    "os_hash_value": "637296b9f819841c3ccebb2218b6154c293281b90827c119b9095f159d80426434bc833f452d796b06468496caba23c2d98d50f5fbbec417f54b3585167736d4"
  },
  {
    "container_format": "bare",
    "min_ram": 0,
    "updated_at": "2021-09-20T06:37:21Z",
    "file": "/v2/images/6b2baa89-5782-48a0-989c-19773afbeb0f/file",
    "owner": "b7e277b7d53449f9941b9ea61cae99e3",
    "id": "6b2baa89-5782-48a0-989c-19773afbeb0f",
    "size": 1412562944,
    "self": "/v2/images/6b2baa89-5782-48a0-989c-19773afbeb0f",
    "disk_format": "qcow2",
    "os_hash_algo": "sha512",
    "schema": "/v2/schemas/image",
    "status": "active",
    "tags": [
      "application_stack"
    ],
    "hw_qemu_guest_agent": "yes",
    "visibility": "public",
    "min_disk": 0,
    "virtual_size": null,
    "name": "Minecraft: Java Edition Server-Ubuntu-20.04 LTS-x86_64",
    "checksum": "50dea569f3edda09f71081f6f975f816",
    "created_at": "2021-09-20T06:15:45Z",
    "os_hidden": false,
    "protected": false,
    "os_hash_value": "e00a76e278975271a9160ddb524e09e9b8a5932b0b256a0aec6572769567a7529dca54e68bc86d3dd045c1ebd57711bd596ae96fc5a19ef98e35a474177b00c6"
  },
  {
    "container_format": "bare",
    "min_ram": 0,
    "updated_at": "2021-08-23T05:58:48Z",
    "file": "/v2/images/f19348a7-793b-4c86-b6ed-f6aa55709ffa/file",
    "owner": "b7e277b7d53449f9941b9ea61cae99e3",
    "id": "f19348a7-793b-4c86-b6ed-f6aa55709ffa",
    "size": 1162346496,
    "self": "/v2/images/f19348a7-793b-4c86-b6ed-f6aa55709ffa",
    "disk_format": "qcow2",
    "os_hash_algo": "sha512",
    "schema": "/v2/schemas/image",
    "status": "active",
    "tags": [
      "application_stack"
    ],
    "hw_qemu_guest_agent": "yes",
    "visibility": "public",
    "min_disk": 0,
    "virtual_size": null,
    "name": "Jenkins-Ubuntu-20.04 LTS-x86_64",
    "checksum": "5e6dead134312f06eb696ee8d15098f9",
    "created_at": "2021-08-23T05:37:33Z",
    "os_hidden": false,
    "protected": false,
    "os_hash_value": "d5e50b487d52e1677b8bd3d7820e6d937fb277121d90627728afcaa850b09962d462892bcc01ea8714f76ff9742806c6e0baa0dd2fd60ed9f6a4872957dd8f68"
  },
  {
    "container_format": "bare",
    "min_ram": 0,
    "updated_at": "2021-08-18T10:33:15Z",
    "file": "/v2/images/56a9ba2c-7d3f-4508-9704-94d617771601/file",
    "owner": "b7e277b7d53449f9941b9ea61cae99e3",
    "id": "56a9ba2c-7d3f-4508-9704-94d617771601",
    "size": 1028063232,
    "self": "/v2/images/56a9ba2c-7d3f-4508-9704-94d617771601",
    "disk_format": "qcow2",
    "os_hash_algo": "sha512",
    "schema": "/v2/schemas/image",
    "status": "active",
    "tags": [
      "application_stack"
    ],
    "hw_qemu_guest_agent": "yes",
    "visibility": "public",
    "min_disk": 0,
    "virtual_size": null,
    "name": "LAMP-Ubuntu-20.04 LTS-x86_64",
    "checksum": "9f03b26cf5b26877690017a4e381fe1d",
    "created_at": "2021-08-18T09:36:26Z",
    "os_hidden": false,
    "protected": false,
    "os_hash_value": "0c36f719a44aae08073b3f093c89441adeb617715c912b6bfc3cdddd1bf575af0a283df018c72b6be26dca6feaf9b1a0ab0a8808eede81760cbf89018a56ddb3"
  },
  {
    "container_format": "bare",
    "min_ram": 0,
    "updated_at": "2021-08-18T10:33:32Z",
    "file": "/v2/images/19f57902-11b3-401f-9abe-d986ca3cc2d9/file",
    "owner": "b7e277b7d53449f9941b9ea61cae99e3",
    "id": "19f57902-11b3-401f-9abe-d986ca3cc2d9",
    "size": 1043267584,
    "self": "/v2/images/19f57902-11b3-401f-9abe-d986ca3cc2d9",
    "disk_format": "qcow2",
    "os_hash_algo": "sha512",
    "schema": "/v2/schemas/image",
    "status": "active",
    "tags": [
      "application_stack"
    ],
    "hw_qemu_guest_agent": "yes",
    "visibility": "public",
    "min_disk": 0,
    "virtual_size": null,
    "name": "MySQL-Ubuntu-20.04 LTS-x86_64",
    "checksum": "b3590d3632b89d1a44bba5adc1acc4ca",
    "created_at": "2021-08-18T09:36:23Z",
    "os_hidden": false,
    "protected": false,
    "os_hash_value": "66178716abc5fad106c511799d26379225366b18bb7233282d62a2c0191cd28c8cc0525559455a54e1db99b8d90400023b491f5d4cbaffc3f9a2700d2be9b111"
  },
  {
    "container_format": "bare",
    "min_ram": 0,
    "updated_at": "2021-08-18T10:31:27Z",
    "file": "/v2/images/2af58d5d-6a63-4f21-a428-7e1c5e04091c/file",
    "owner": "b7e277b7d53449f9941b9ea61cae99e3",
    "id": "2af58d5d-6a63-4f21-a428-7e1c5e04091c",
    "size": 1025048576,
    "self": "/v2/images/2af58d5d-6a63-4f21-a428-7e1c5e04091c",
    "disk_format": "qcow2",
    "os_hash_algo": "sha512",
    "schema": "/v2/schemas/image",
    "status": "active",
    "tags": [
      "application_stack"
    ],
    "hw_qemu_guest_agent": "yes",
    "visibility": "public",
    "min_disk": 0,
    "virtual_size": null,
    "name": "LEMP-Ubuntu-20.04 LTS-x86_64",
    "checksum": "9765a0111335383e65ece597ea2bf28a",
    "created_at": "2021-08-18T09:36:20Z",
    "os_hidden": false,
    "protected": false,
    "os_hash_value": "402630e7f5936171a4f4d52245de988d9026dd28911454ce10a04811832e6c606005f6de01cb92590d2aaa94c220adfc9dcd671a66853d2fd8a91c14cafa2505"
  },
  {
    "container_format": "bare",
    "min_ram": 0,
    "updated_at": "2021-08-18T10:33:57Z",
    "file": "/v2/images/5d18b8e9-017d-4cea-92de-2c8ea39e3cb3/file",
    "owner": "b7e277b7d53449f9941b9ea61cae99e3",
    "id": "5d18b8e9-017d-4cea-92de-2c8ea39e3cb3",
    "size": 1086586880,
    "self": "/v2/images/5d18b8e9-017d-4cea-92de-2c8ea39e3cb3",
    "disk_format": "qcow2",
    "os_hash_algo": "sha512",
    "schema": "/v2/schemas/image",
    "status": "active",
    "tags": [
      "application_stack"
    ],
    "hw_qemu_guest_agent": "yes",
    "visibility": "public",
    "min_disk": 0,
    "virtual_size": null,
    "name": "Docker-Ubuntu-20.04 LTS-x86_64",
    "checksum": "63ac4aba5ca4acd4871353227e3ee2e1",
    "created_at": "2021-08-18T09:36:16Z",
    "os_hidden": false,
    "protected": false,
    "os_hash_value": "851489fa45afacab1061e7d382ae5f60e8d58e776d27ae8fbe4c00585f3976b8d66de11b50a733b271b226c438dfea7d4677c0cab15f98418fdc72347c017488"
  },
  {
    "container_format": "bare",
    "min_ram": 0,
    "updated_at": "2022-03-04T13:07:01Z",
    "file": "/v2/images/f977ae61-dfc9-4f07-84a8-29543fe6aa39/file",
    "owner": "b7e277b7d53449f9941b9ea61cae99e3",
    "id": "f977ae61-dfc9-4f07-84a8-29543fe6aa39",
    "size": 1196556288,
    "self": "/v2/images/f977ae61-dfc9-4f07-84a8-29543fe6aa39",
    "disk_format": "qcow2",
    "os_hash_algo": "sha512",
    "schema": "/v2/schemas/image",
    "status": "active",
    "tags": [
      "application_stack"
    ],
    "hw_qemu_guest_agent": "yes",
    "visibility": "public",
    "min_disk": 0,
    "virtual_size": null,
    "name": "OpenVPN-Ubuntu-20.04 LTS-x86_64",
    "checksum": "997ff2b6d3e85ae47dd20452baea01d7",
    "created_at": "2022-03-04T13:06:24Z",
    "os_hidden": false,
    "protected": false,
    "os_hash_value": "f40f6ce2f333e2780b5c3662282b5c110ec918c92e7ccee5dd0f9249ef031694beb63b42e46bf7ada3871166d2d7d599fc78866030fc7289e73d944b52d956d7"
  },
  {
    "container_format": "bare",
    "min_ram": 0,
    "updated_at": "2022-03-18T12:17:32Z",
    "file": "/v2/images/52f601e9-cee8-4bb9-8491-a977b647feab/file",
    "owner": "b7e277b7d53449f9941b9ea61cae99e3",
    "id": "52f601e9-cee8-4bb9-8491-a977b647feab",
    "size": 1219035136,
    "self": "/v2/images/52f601e9-cee8-4bb9-8491-a977b647feab",
    "disk_format": "qcow2",
    "os_hash_algo": "sha512",
    "schema": "/v2/schemas/image",
    "status": "active",
    "tags": [
      "application_stack"
    ],
    "hw_qemu_guest_agent": "yes",
    "visibility": "public",
    "min_disk": 0,
    "virtual_size": null,
    "name": "Nakama-Ubuntu-20.04 LTS-x86_64",
    "checksum": "193b40c21702d6bd9896e76922ebfae2",
    "created_at": "2022-03-18T12:16:46Z",
    "os_hidden": false,
    "protected": false,
    "os_hash_value": "f1e2765ba2b6732c22c0bf2fe6901caba4abd7c54735dc81b66dbe6d190d558f8ae0318a8001cd64d783d7feab61fc0e49e1c9194a14692c0d5785c3006a912f"
  },
  {
    "container_format": "bare",
    "min_ram": 0,
    "updated_at": "2022-03-18T12:17:46Z",
    "file": "/v2/images/463afd49-a20e-4c32-8951-11b5c093e747/file",
    "owner": "b7e277b7d53449f9941b9ea61cae99e3",
    "id": "463afd49-a20e-4c32-8951-11b5c093e747",
    "size": 2075813376,
    "self": "/v2/images/463afd49-a20e-4c32-8951-11b5c093e747",
    "disk_format": "qcow2",
    "os_hash_algo": "sha512",
    "schema": "/v2/schemas/image",
    "status": "active",
    "tags": [
      "application_stack"
    ],
    "hw_qemu_guest_agent": "yes",
    "visibility": "public",
    "min_disk": 0,
    "virtual_size": null,
    "name": "GitLab-Ubuntu-20.04 LTS-x86_64",
    "checksum": "3e6d008dae5d556064886e450ea4c9df",
    "created_at": "2022-03-18T12:16:44Z",
    "os_hidden": false,
    "protected": false,
    "os_hash_value": "ce7ab75781e28fe0d440add09b9313e6c921f8e5f31566a5885ee5bb50b40fd533600db52a5e0765c8badfdd4cdcf58098ea0ab7e838b84b03268cc7b9c09bf8"
  },
  {
    "container_format": "bare",
    "min_ram": 0,
    "updated_at": "2022-06-10T10:25:42Z",
    "file": "/v2/images/b7f9a4c2-74c4-410b-9b13-76e8cc57c0a8/file",
    "owner": "b7e277b7d53449f9941b9ea61cae99e3",
    "id": "b7f9a4c2-74c4-410b-9b13-76e8cc57c0a8",
    "size": 1032716288,
    "self": "/v2/images/b7f9a4c2-74c4-410b-9b13-76e8cc57c0a8",
    "disk_format": "qcow2",
    "os_hash_algo": "sha512",
    "schema": "/v2/schemas/image",
    "status": "active",
    "tags": [
      "application_stack"
    ],
    "hw_qemu_guest_agent": "yes",
    "visibility": "public",
    "min_disk": 0,
    "virtual_size": null,
    "name": "Cloudron-Ubuntu-20.04 LTS-x86_64",
    "checksum": "7ca3c9364996c90551c74c0d96bd10b4",
    "created_at": "2022-06-10T10:25:09Z",
    "os_hidden": false,
    "protected": false,
    "os_hash_value": "7a6caea931025b8b3ff9107a39f74d78f3e06db0fc2cb0f79b64be70ec750de7fc092bea9354cee3da189140eaa695a7c0703043052db62d3cd01b15a10a511b"
  },
  {
    "container_format": "bare",
    "min_ram": 0,
    "updated_at": "2022-06-10T10:25:13Z",
    "file": "/v2/images/887e2205-ae38-42ab-b9f2-e68a7237b9f2/file",
    "owner": "b7e277b7d53449f9941b9ea61cae99e3",
    "id": "887e2205-ae38-42ab-b9f2-e68a7237b9f2",
    "size": 1033502720,
    "self": "/v2/images/887e2205-ae38-42ab-b9f2-e68a7237b9f2",
    "disk_format": "qcow2",
    "os_hash_algo": "sha512",
    "schema": "/v2/schemas/image",
    "status": "active",
    "tags": [
      "application_stack"
    ],
    "hw_qemu_guest_agent": "yes",
    "visibility": "public",
    "min_disk": 0,
    "virtual_size": null,
    "name": "CyberPanel-Ubuntu-20.04 LTS-x86_64",
    "checksum": "458ac3adc0e63c3e54da16143d4c63a9",
    "created_at": "2022-06-10T10:24:39Z",
    "os_hidden": false,
    "protected": false,
    "os_hash_value": "ba6f89ff8554ea1855e71d43ad5033a7483b30207b4b4f7a0ec02cdde75501c7a003c4c9cd48326e055f2c36c13630ee72f59c2ef5303aed7b21ea099cc75993"
  },
  {
    "container_format": "bare",
    "min_ram": 0,
    "updated_at": "2022-06-20T11:17:47Z",
    "file": "/v2/images/26148fb4-306f-43d5-829b-632f87d41dbe/file",
    "owner": "b7e277b7d53449f9941b9ea61cae99e3",
    "id": "26148fb4-306f-43d5-829b-632f87d41dbe",
    "size": 1035206656,
    "self": "/v2/images/26148fb4-306f-43d5-829b-632f87d41dbe",
    "disk_format": "qcow2",
    "os_hash_algo": "sha512",
    "schema": "/v2/schemas/image",
    "status": "active",
    "tags": [
      "application_stack"
    ],
    "hw_qemu_guest_agent": "yes",
    "visibility": "public",
    "min_disk": 0,
    "virtual_size": null,
    "name": "OpenLiteSpeed WordPress-Ubuntu-20.04 LTS-x86_64",
    "checksum": "53b8188e8492be6980f4ac77fb7f35c1",
    "created_at": "2022-06-10T10:20:50Z",
    "os_hidden": false,
    "protected": false,
    "os_hash_value": "c563d12e4ffff57f9f782b3bcb0c1361d6423d399d4bf780935dcfaa890880588167e144f3ee1ae3d1e51b4ff50a18064c641431db63e43c7353a3358c4a03ad"
  },
  {
    "container_format": "bare",
    "min_ram": 0,
    "updated_at": "2022-06-20T11:17:18Z",
    "file": "/v2/images/77470ceb-91a5-4483-b693-19b221dfb5c8/file",
    "owner": "b7e277b7d53449f9941b9ea61cae99e3",
    "id": "77470ceb-91a5-4483-b693-19b221dfb5c8",
    "size": 1044119552,
    "self": "/v2/images/77470ceb-91a5-4483-b693-19b221dfb5c8",
    "disk_format": "qcow2",
    "os_hash_algo": "sha512",
    "schema": "/v2/schemas/image",
    "status": "active",
    "tags": [
      "application_stack"
    ],
    "hw_qemu_guest_agent": "yes",
    "visibility": "public",
    "min_disk": 0,
    "virtual_size": null,
    "name": "OpenLiteSpeed NodeJS-Ubuntu-20.04  LTS-x86_64",
    "checksum": "4fa11a6ccd91640f2a29fadaf3fd7043",
    "created_at": "2022-06-10T10:16:38Z",
    "os_hidden": false,
    "protected": false,
    "os_hash_value": "239d548061725341ef8e4abdf776d05ce58f0be1671e4e1ac753ec86e8848369e925bc2237003c7d80beb87a43825fb97eade1e27bee693031c0cf3db11e5105"
  }
];
export default AppImages; 